// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__30j92","footer":"ModalFilter_footer__gs3L4"};